<template>
  <b-card class="no-border animated">
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2">{{ header }}</h5>
    </div>
    <b-form @submit.prevent="onSubmit()">
      <legend>Detail</legend>
      <div class="form-row">
        <div class="form-group col-md-12">
          <label>Name</label>
          <input
            v-model.trim="form.name"
            type="text"
            placeholder="Enter customer name"
            class="form-control"
            name="name"
            v-validate="'required'"
            :class="{'is-invalid': errors.has('name')}">
          <b-form-feedback>{{ errors.first('name') }}</b-form-feedback>
        </div>
      </div>
      <legend>Address</legend>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="input_address_country">Country</label>
          <input
            name="country"
            v-validate="'required'"
            type="text"
            v-model="form.address.country"
            class="form-control"
            id="input_address_country"
            placeholder="Country"
            :class="{'is-invalid': errors.has('country')}">
          <b-form-feedback>{{ errors.first('country') }}</b-form-feedback>
        </div>
        <div class="form-group col-md-6">
          <label for="input_address_state">State</label>
          <input
            type="text"
            v-model="form.address.state"
            class="form-control"
            id="input_address_state"
            placeholder="State">
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="input_address_city">City</label>
          <input
            type="text"
            v-model="form.address.city"
            class="form-control"
            id="input_address_city"
            placeholder="City">
        </div>
        <div class="form-group col-md-6">
          <label for="input_address_zip_code">Zip / Postal Code</label>
          <input
            type="text"
            v-model="form.address.zip_code"
            class="form-control"
            id="input_address_zip_code"
            placeholder="Zip / Postal Code">
        </div>
      </div>
      <b-form-group
        id="label_address_address1"
        label="Address 1"
        label-for="input_address_address1">
        <b-form-input
          id="input_address_address1"
          type="text"
          v-model="form.address.address1"
          placeholder="Address line 1"/>
      </b-form-group>
      <b-form-group
        id="label_address_address2"
        label="Address 2"
        label-for="input_address_address2">
        <b-form-input
          id="input_address_address2"
          type="text"
          v-model="form.address.address2"
          placeholder="Address line 2"/>
      </b-form-group>
      <hr>
      <b-button
        type="submit"
        id="createBtn"
        :disabled="disabled"
        variant="primary">
        <span v-if="beforeClick">Save changes</span>
        <span v-else> Loading..</span>
        <i v-if="loadingSpinner" class="fa fa-spinner fa-spin"></i>
      </b-button>
      <b-button
        @click="onCancel()"
        type="reset"
        variant="outline-secondary"
        class="pull-right">Cancel</b-button>
    </b-form>
  </b-card>
</template>
<script>
import tmsApi from '@/api/tmsApi';

import { isEmpty, cloneDeep } from 'lodash';

export default {
  name: 'customer_create_edit',
  data() {
    return {
      form: {
        id: null,
        parent: '',
        name: '',
        type: 'CUSTOMER',
        address: {
          country: '',
          state: '',
          city: '',
          zip_code: '',
          address: '',
        },
      },
      loadingSpinner: false,
      beforeClick: true,
      disabled: false,
    };
  },
  created() {
    const { companyId } = this.$route.params;
    const action = companyId ? 'edit' : 'create';
    const breadcrumb = [
      { to: '', name: 'Home' },
      { to: 'shipment_md', name: 'Shipment MD' },
      { to: 'customers', name: 'Customers' },
      { to: companyId, name: 'Detail' },
      { to: 'edit', name: 'Edit' },
    ];
    const isEdit = action === 'edit';

    if (!isEdit) {
      breadcrumb.splice(3, 2);
      breadcrumb.push({ to: 'create', name: 'Create' });
    } else {
      this.$store.commit('companies/SET_DETAIL_ID', companyId);
      this.$store.dispatch('companies/LOAD_DETAIL_DATA');
    }

    this.$store.commit('SET_BREADCRUMB_ITEMS', breadcrumb);
  },
  computed: {
    detailedInfo() {
      const detailedInfo = this.isEdit ? this.$store.getters['companies/get_detail_data'] : {};
      return detailedInfo;
    },
    displayName() {
      const { name } = this.detailedInfo;
      return name;
    },
    header() {
      const header = this.isEdit
        ? `Edit Customer : ${this.displayName}`
        : 'Create New Customer';
      return header;
    },
    userData() {
      return this.$store.getters.userData;
    },
    isEdit() {
      return !isEmpty(this.$route.params.companyId);
    },
  },
  watch: {
    detailedInfo(data) {
      this.form = cloneDeep(data);
    },
  },
  methods: {
    onSubmit() {
      this.validate().then((valid) => {
        if (valid) {
          this.loadingSpinner = true;
          this.beforeClick = false;
          this.disabled = true;
          let { companyId: cmpId } = this.$route.params;
          const { company_id: companyId, username, account } = this.userData;
          const { plain_password: password } = account;
          const action = this.isEdit ? 'UPDATE_DATA' : 'CREATE_SUBSIDIARY';

          if (action === 'CREATE_SUBSIDIARY') this.form.parent = companyId;

          this.$store.dispatch(`companies/${action}`, this.form).then((company) => {
            const payload = {
              username,
              password,
            };

            tmsApi.login(payload).then((resp) => {
              if (typeof resp.token === 'string') {
                this.$store.dispatch('SAVE_LOGIN_STATE', resp);
                cmpId = this.isEdit ? cmpId : company.id;
                this.$router.push(`/shipment_md/customers/${cmpId}`);
              } else {
                this.setErrorResponse(resp.error);
              }
            });
          });
        } else {
          this.loadingSpinner = false;
          this.beforeClick = true;
          this.disabled = false;
        }
      });
    },
    validate() {
      return this.$validator.validateAll();
    },
    onCancel() {
      const { companyId } = this.$route.params;
      if (this.isEdit) {
        this.$router.push(`/shipment_md/customers/${companyId}`);
      } else {
        this.$router.push('/shipment_md/customers');
      }
    },
  },
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/pages/shipment_md/customers/CreateEdit.vue